export default "/static/webpack/media/undraw_selecting_team.756310dc.svg";